import { render, staticRenderFns } from "./TicketCreation.vue?vue&type=template&id=5fac8b09&"
import script from "./TicketCreation.vue?vue&type=script&lang=js&"
export * from "./TicketCreation.vue?vue&type=script&lang=js&"
import style0 from "./TicketCreation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports